<template>
    <div class="content">
        <slot />
    </div>
</template>

<script>
    export default {
        name: 'app-content'
    }
</script>

<style lang="scss" scoped>
    .content {
        @apply .p-6;

        margin-top: 3.75rem;
        margin-left: 15.625rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/template/Content.vue